module.exports = __webpack_public_path__ + "images/header-harmonie-muenchen-mitglieder-26cbac299ca7e719990966d402c4a6c3.jpg";